import { createEvent, restore } from "effector";
import { GameCategory } from "~/common/data/games";

export const setCategoryFilter = createEvent<GameCategory | null>();
export const $categoryFilter = restore(setCategoryFilter, null);

export const setSearchQuery = createEvent<string>();
export const $searchQuery = restore(setSearchQuery, "");
